import { DateTimeFormatOptions } from 'luxon'
import { useTranslation } from 'react-i18next'

import { Box } from '@/components/ui/box'
import { Text } from '@/components/ui/typography'
import { IApprovalDetail, ITaskDetail } from '@/types/tasksApprovals'
import { formatDate } from '@/utils/date'

const RequestPeriod = ({ details }: { details: ITaskDetail | IApprovalDetail }) => {
    const { t } = useTranslation()
    const formatDateOptions = {
        weekday: 'long',
        month: 'long',
        day: '2-digit',
        year: 'numeric',
    } as DateTimeFormatOptions
    const startDate = details.fields.filter((field) => field.name === 'Start Date')[0].value as string
    const endDate = details.fields.filter((field) => field.name === 'End Date')[0].value as string
    return (
        <Box pb="16px" px="24px">
            <Text fontSize={12} pb="4px">
                {t('tasksApprovals.sapLeaveRequestDrawer.body.requestPeriod')}
            </Text>
            <Text fontSize={14} fontWeight="bold">
                {formatDate(startDate, formatDateOptions)} - {formatDate(endDate, formatDateOptions)}
            </Text>
        </Box>
    )
}

export default RequestPeriod
